import './App.css';
import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Login from './components/Login';
import ForgotPassword from './components/ForgetPassword';
import { Toaster } from 'react-hot-toast';
import Dashboard from './components/Dashboard';

import PrivateRoute from './routes/PrivateRoute';
import PublicRoute from './routes/PublicRoute';
import ResetPassword from './components/ResetPassword';
import Header from './components/Header';
import Footer from './components/Footer';
import Sidebar2 from './components/Sidebar';
import { authRoutes, resetPasswordRoute } from './components/common';
import Category from './components/category/Category';
import Company from './components/company/Company';
import Years from './components/year/Year';
import UserProfile from './components/userProfile/UserProfile';
import { AuthProvider } from './context/Context';
import Units from './components/units/Units';
import SignupCard from './components/common/cards/SignupCard';
import PersonalRegisterForm from './components/register/PersonalRegisterForm';
import BusinessRegisterForm from './components/register/BusinessRegisterForm';
import EnterpriseRegisterForm from './components/register/EnterpriseRegisterForm';
import OtpVerification from './components/register/OtpVerification';
import { ROLES } from './routes';
import Employees from './components/companyStructure/Employees';
import TeamHierarchy from './components/companyStructure/TeamHierarchy';
import FinancialEnteries from './components/business&enterpriseMode/FinancialEnteries';
import EnterpriseAndBusinessDashboard from './components/business&enterpriseMode/dashboard/Dashboard';
import PersonalDrive from './components/business&enterpriseMode/drive/PersonalDrive';
import TeamDrive from './components/business&enterpriseMode/drive/TeamDrive';
import SingleTeamDrive from './components/business&enterpriseMode/drive/TeamDrive/SingleTeamDrive';
import Invitation from './components/business&enterpriseMode/roleMember/Invitation';
import SheetInvitation from './components/business&enterpriseMode/drive/Sheet/SheetInvitation';
import PricingPlans from './components/stripe/PricingPlans';
import ComingSoon from './components/common/ComingSoon';
import Settings from './components/Settings';
import Help from './components/Help';
import Storage from './components/Storage';
import TermsOfService from './components/common/TermsOfService';
import PrivacyPolicy from './components/common/PrivacyPolicy';

const Layout = ({ children }) => {
  const { pathname } = useLocation();
  const isAuthRoute = authRoutes.includes(pathname) || pathname.startsWith(resetPasswordRoute);

  return (
    <>
      {!isAuthRoute && <Sidebar2 />}
      {!isAuthRoute && <Header />}
      <main className={`home-section ${isAuthRoute && '!w-full md:!w-auto '}`} style={isAuthRoute ? { left: 0 } : {}}>{children}</main>
      {/* {!isAuthRoute && <Footer />} */}
    </>
  );
};

function App() {
  return (
    <BrowserRouter>
    <AuthProvider>
      <Layout>
        <Routes>
          {/* Private Routes */}
          <Route path="/dashboard/:tab" element={<PrivateRoute allowedRoles={[ROLES.PERSONAL_USER]}><Dashboard /></PrivateRoute>} />
          <Route path='/category' element={<PrivateRoute allowedRoles={[ROLES.PERSONAL_USER]}><Category /></PrivateRoute>} />
          <Route path='/company' element={<PrivateRoute allowedRoles={[ROLES.PERSONAL_USER]}><Company /></PrivateRoute>} />
          <Route path='/time-period' element={<PrivateRoute allowedRoles={[ROLES.PERSONAL_USER]}><Years /></PrivateRoute>} />
          <Route path='/units' element={<PrivateRoute allowedRoles={[ROLES.PERSONAL_USER]}><Units /></PrivateRoute>} />
          <Route path='/profile' element={<PrivateRoute allowedRoles={[ROLES.ADMIN, ROLES.COMPANY_HEAD, ROLES.TEAM_HEAD, ROLES.MEMBER, ROLES.PERSONAL_USER, ROLES.COMPANY_MEMBER]}><UserProfile /></PrivateRoute>} />
          <Route path='/company/employees' element={<PrivateRoute allowedRoles={[ROLES.COMPANY_HEAD, ROLES.TEAM_HEAD, ROLES.MEMBER]}><Employees /></PrivateRoute>} />
          <Route path='/company/team-hierarchy' element={<PrivateRoute allowedRoles={[ROLES.COMPANY_HEAD, ROLES.TEAM_HEAD, ROLES.MEMBER]}><TeamHierarchy /></PrivateRoute>} />
          <Route path='/entries' element={<PrivateRoute allowedRoles={[ROLES.COMPANY_HEAD, ROLES.TEAM_HEAD, ROLES.MEMBER]}><FinancialEnteries /></PrivateRoute>} />
          <Route path='/dashboard' element={<PrivateRoute allowedRoles={[ROLES.COMPANY_HEAD, ROLES.TEAM_HEAD, ROLES.MEMBER, ROLES.COMPANY_MEMBER]}><EnterpriseAndBusinessDashboard /></PrivateRoute>} />
          <Route path='/personal/drive' element={<PrivateRoute allowedRoles={[ROLES.COMPANY_HEAD, ROLES.TEAM_HEAD, ROLES.MEMBER]}><PersonalDrive /></PrivateRoute>} />
          <Route path='/teams/drive' element={<PrivateRoute allowedRoles={[ROLES.COMPANY_HEAD, ROLES.TEAM_HEAD, ROLES.MEMBER]}><TeamDrive /></PrivateRoute>} />
          <Route path='/teams/:id/drive' element={<PrivateRoute allowedRoles={[ROLES.COMPANY_HEAD, ROLES.TEAM_HEAD, ROLES.MEMBER]}><SingleTeamDrive /></PrivateRoute>} />
          <Route path='/team-invitation/:token' element={<PrivateRoute allowedRoles={[ROLES.TEAM_HEAD,ROLES.MEMBER, ROLES.COMPANY_MEMBER]}><Invitation /></PrivateRoute>} />
          <Route path='/sheet-invitation/:token' element={<PrivateRoute allowedRoles={[ROLES.TEAM_HEAD,ROLES.MEMBER, ROLES.COMPANY_HEAD, ROLES.PERSONAL_USER]}><SheetInvitation /></PrivateRoute>} />
          <Route path='/plans' element={<PrivateRoute  allowedRoles={[ROLES.TEAM_HEAD,ROLES.MEMBER, ROLES.COMPANY_HEAD, ROLES.PERSONAL_USER]}><PricingPlans /></PrivateRoute>} />
          <Route path='/coming-soon' element={<PrivateRoute allowedRoles={[ROLES.ADMIN, ROLES.COMPANY_HEAD, ROLES.TEAM_HEAD, ROLES.MEMBER, ROLES.PERSONAL_USER, ROLES.COMPANY_MEMBER]}><ComingSoon /></PrivateRoute>} />
          <Route path='/settings' element={<PrivateRoute allowedRoles={[ROLES.ADMIN, ROLES.COMPANY_HEAD, ROLES.TEAM_HEAD, ROLES.MEMBER, ROLES.PERSONAL_USER, ROLES.COMPANY_MEMBER]}><Settings /></PrivateRoute>} />
          <Route path='/help' element={<PrivateRoute allowedRoles={[ROLES.ADMIN, ROLES.COMPANY_HEAD, ROLES.TEAM_HEAD, ROLES.MEMBER, ROLES.PERSONAL_USER, ROLES.COMPANY_MEMBER]}><Help /></PrivateRoute>} />
          <Route path='/storage' element={<PrivateRoute allowedRoles={[ROLES.ADMIN, ROLES.COMPANY_HEAD, ROLES.TEAM_HEAD, ROLES.MEMBER, ROLES.PERSONAL_USER, ROLES.COMPANY_MEMBER]}><Storage /></PrivateRoute>} />


          {/* Public Routes */}
          <Route path="/" element={<PublicRoute><Login /></PublicRoute>} />
          <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
          <Route path="/register" element={<PublicRoute><SignupCard /></PublicRoute>} />
          <Route path="/register/personal" element={<PublicRoute><PersonalRegisterForm /></PublicRoute>} />
          <Route path="/register/business" element={<PublicRoute><BusinessRegisterForm /> </PublicRoute>} />
          <Route path="/register/enterprise" element={<PublicRoute><EnterpriseRegisterForm /></PublicRoute>} />
          <Route path="/otp-verification" element={<PublicRoute><OtpVerification /></PublicRoute>} />
          <Route path="/forgot-password" element={<PublicRoute><ForgotPassword /></PublicRoute>} />
          <Route path="/reset-password/:token" element={<PublicRoute><ResetPassword /></PublicRoute>} />
          <Route path="/terms-of-service" element={<PublicRoute><TermsOfService /></PublicRoute>} />
          <Route path="/privacy-policy" element={<PublicRoute><PrivacyPolicy /></PublicRoute>} />
          <Route path="*" element={<PublicRoute><Login /></PublicRoute>} />
        </Routes>
      </Layout>
      
      <Toaster
        position="top-right"
        toastOptions={{
          animation: 'slide',
          className: 'custom-toast',
          style: {
            background: '#2A2F2E',
            color: '#FFFFFF',
          },
          success: {
            iconTheme: {
              primary: '#AEF468',
              secondary: '#000000',
            },
          },
        }}
      />
      </AuthProvider>
      
    </BrowserRouter>
  );
}

export default App;
